<script>
    import { MaterialApp, Container, Select, Row, Button } from "svelte-materialify/src";
    import * as d3 from "d3";
    import { onMount } from "svelte";
    import legend from "d3-svg-legend";
    import * as druid from "@saehrimnir/druidjs/dist/druid.js"

    let data;
    let matrix = [[]];
    let columns = [];

    const width = 500;
    const height = width;
    const margin = 20;
    const innerPad = 20;

    const issues_names = ['resolution_too_low', 'shapes_too_thinsmall',
                                'issues_with_text_size_or_font', 'text_broken',
                                'brightness_contrast_too_low', 'colors_not_distinguishable',
                                'colors_barely_distinguishable', 'continous_color_scale_ambiguos',
                                'highlighted_elements_do_not_pop_out',
                                'loss_of_detailed_information_content', 'fabricated_information'];
    const helpful_names = ['works_with_one_color', 'has_labels', 'descriptive_text',
                'texture_helps', 'colors_dont_change', 'order_helps'];

    const all_names = issues_names.concat(helpful_names);

    const dict = {
        'resolution_too_low' : "lores", 
        'shapes_too_thinsmall': "thin",
        'issues_with_text_size_or_font': "textize", 
        'text_broken': "brotex",
        'brightness_contrast_too_low': "locont", 
        'colors_not_distinguishable': "colnodi",
        'colors_barely_distinguishable': "colbadi", 
        'continous_color_scale_ambiguos': "scambi",
        'highlighted_elements_do_not_pop_out': "hinopo",
        'loss_of_detailed_information_content': "infloss", 
        'fabricated_information': "fabinf",
        'works_with_one_color': "singcol", 
        'has_labels': "labels", 
        'descriptive_text': "desc",
        'texture_helps': "texture", 
        'colors_dont_change': "colstay", 
        'order_helps': "order",
        "accessibility":"accessibility",
    }

    $: x = d3.scaleBand().domain(d3.range(0, matrix.length)).range([0, width]);
    const c = d3.scaleSequentialSqrt(d3.interpolateRdGy).domain([-1, 1]);

    let cvds = ["total", 'Deuteranomaly', 'Monochromacy', 'Protanomaly', 'Tritanomaly'];
    let cvd = cvds[0];
    //let dict = {"accessibility":"accessibility","resolution_too_low":"resolution too low","shapes_too_thinsmall":"shapes too thinsmall","issues_with_text_size_or_font":"issues with text size or font","text_broken":"text broken","brightness_contrast_too_low":"brightness contrast too low","colors_not_distinguishable":"colors not distinguishable","colors_barely_distinguishable":"colors barely distinguishable","continous_color_scale_ambiguos":"continous color scale ambiguos","highlighted_elements_do_not_pop_out":"highlighted elements do not pop out","loss_of_detailed_information_content":"loss of detailed information content","fabricated_information":"fabricated information","works_with_one_color":"works with one color","has_labels":"has labels","descriptive_text":"descriptive text","texture_helps":"texture helps","colors_dont_change":"colors dont change","order_helps":"order helps"}

    let issue_dendogram;
    let helpful_dendogram;
    let occurences = [];

    $: y_occ = d3.scaleLinear().domain([0, d3.max(occurences)]).range([0, 80]);

    const init = async(cvd) => {
        data = await d3.csv(`${window.location.href}data/correlation/${cvd}.csv`, d3.autoType);
        console.log("correlation", data)
        columns = data.columns.slice(2);
        matrix = columns.map((row, i) => columns.map(col => data.find(d => d[""] == row)[col]));

        let issue_matrix = issues_names.map((row) => issues_names.map(col => data.find(d => d[""] == row)[col]));
        //console.log("issue_matrix", issue_matrix)
        issue_dendogram = get_dendogram(issue_matrix);
        let issue_perm = issue_dendogram.order //reorder.optimal_leaf_order()(issue_matrix);
        issue_perm = issue_perm.map(i => columns.findIndex(c => c == issues_names[i]))


        let helpful_matrix = helpful_names.map((row) => helpful_names.map(col => data.find(d => d[""] == row)[col]));
        //console.log("helpful_matrix", helpful_matrix)
        helpful_dendogram = get_dendogram(helpful_matrix);
        let helpful_perm = helpful_dendogram.order //reorder.optimal_leaf_order()(helpful_matrix);
        helpful_perm = helpful_perm.map(i => columns.findIndex(c => c == helpful_names[i]))

        
        let perm = issue_perm.concat(helpful_perm)//reorder.optimal_leaf_order()(matrix);


        console.log(perm)
        matrix = matrix
            .map((row, i) => matrix[perm[i]])
            .map(row => perm.map(i => row[i]))
        columns = perm.map((i) => columns[i])


        let res = await d3.csv(`${window.location.href}data/all_data_with_cvd_without_extra-1308.csv`, d3.autoType);
        occurences = columns.map(col => res.reduce((a, b) => a + b[col], 0)).map(d => d / res.length * 100)
        console.log("data", res, occurences)
        x = d3.scaleBand().domain(d3.range(0, matrix.length)).range([0, width]);
        //draw_legend(cvd, x.step())
    }

    //onMount(() => init(cvd))
    $: init(cvd)
/* 
    let legendSvg;
    $: draw_legend(cvd, x.step()) */

    /* function draw_legend(t, w) {
        const svg = d3.select(legendSvg)
        const l = legend.legendColor()
            .labelFormat(d3.format(".2f"))
            //.useClass(true)
            .title(`Correlation`)
            .titleWidth(800)
            .orient("vertical")
            .cells(Math.floor((700 - 3 * margin) / w) )
            .shapeWidth(w)
            .scale(c)
            
        l(svg)
    } */

    function get_dendogram(matrix) {
        const H = new druid.Hierarchical_Clustering(druid.Matrix.from(matrix), "complete", druid.euclidean_squared);
        const nodes = H.root.descendants();
        const leaves = nodes.filter(n => n.isLeaf);
        const order = H.root.leaves().map(d => d.index);
        const links = [];
        
        leaves.forEach((node, i) => node.x = i)
        nodes.forEach((node, i) => {
            node.x = node.x ?? d3.mean(node.leaves(), d => d.x);
            [node.left, node.right].forEach(child => {
            if (child) {
                links.push({
                "source": node,
                "target": child
                })
            }
            })
        })
        return {
            "nodes": nodes,
            "links": links,
            "order": order,
        }
    }

    function link({ source, target }) {
        const x1 = source.x * x.step()
        const y1 = (source.depth * 15);
        const x2 = target.x * x.step()
        const y2 = (target.depth * 15);
        const max_radius = 5;
        const x_dist = Math.abs(x1 - x2);
        const y_dist = Math.abs(y1 - y2);
        const radius = Math.min(x_dist, y_dist, max_radius);
        const cx = x1 < x2 ? radius : -radius;
        const counter_clockwise = cx < 0 ? 0 : 1;
        const xa = x2 - cx;
        return `M ${y1} ${x1} V ${xa} a ${radius} ${radius} 0 0 ${counter_clockwise} ${-radius} ${cx} H ${y2}`;
    };

    function saveSvg(svgElement, filename) {
        svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        const svgData = svgElement.outerHTML;
        const preface = '<?xml version="1.0" standalone="no"?>\r\n';
        const svgBlob = new Blob([preface, svgData], {type:"image/svg+xml;charset=utf-8"});
        const svgUrl = URL.createObjectURL(svgBlob);
        const downloadLink = document.createElement("a");
        downloadLink.href = svgUrl;
        downloadLink.download = filename;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }
    
    let svg;
</script>

<MaterialApp theme="light">
    <slot></slot>
    <Container style="position: relative; height: calc(100vh - 58px); margin-top: 58px;">
        <Row>
            <Select items={cvds} bind:value={cvd}>
                <!-- {#each cvds as t, i}
                    <option value={t}>{t}</option>
                {/each} -->
            </Select>
        </Row>
        <Row>
            <svg width={300 + width + 150} height={width + 300} bind:this={svg}>
                <defs>
                    <pattern id="pos"
                        inkscape:stockid="Hatch 2.4 x 45°"
                        x="0" y="0" width="12.712764703048284" height="12.712764703048284"
                        patternUnits="userSpaceOnUse">
                        <path
                            style="stroke:white;stroke-width:0.25mm"
                            d="M -3.7795275590551185,3.7795275590551185 3.7795275590551185,-3.7795275590551185"/>
                        <path
                            style="stroke:white;stroke-width:0.25mm"
                            d="M -3.7795275590551185,16.492292262103405 16.492292262103405,-3.7795275590551185"/>
                        <path
                            style="stroke:white;stroke-width:0.25mm"
                            d="M 8.933237143993166,16.492292262103405 16.492292262103405,8.933237143993166"/>
                    </pattern>
                    <pattern id="neg"
                        inkscape:stockid="Hatch 2.4 x -45°"
                        x="0" y="0" width="12.712764703048284" height="12.712764703048284"
                        patternUnits="userSpaceOnUse">
                        <path
                            style="stroke:white;stroke-width:0.25mm"
                            d="M 8.933237143993166,-3.7795275590551185 16.492292262103405,3.7795275590551185"/>
                        <path
                            style="stroke:white;stroke-width:0.25mm"
                            d="M -3.7795275590551185,-3.7795275590551185 16.492292262103405,16.492292262103405"/>
                        <path
                            style="stroke:white;stroke-width:0.25mm"
                            d="M -3.7795275590551185,8.933237143993166 3.7795275590551185,16.492292262103405"/>
                        </pattern>
                </defs>
                <g transform="translate(150, 180)" shape-render="crispedges">

                    <g transform="translate({width + innerPad + 20}, -95)">
                        <text>Occurences (in %)</text>
                    </g>

                    <text x=-15 y={x.step() / 2} dominant-baseline="central" text-anchor="end" font-weight=900>accessibility</text>
                    {#each columns as col, j}
                    <rect x={x(j) + 1 + (j >= issues_names.length ? innerPad : 0)} width={x.step() - 2} height={x.step() - 2} fill={c(data[0][col])}></rect>
                    <rect x={x(j) + 1 + (j >= issues_names.length ? innerPad : 0)} width={x.step() - 2} height={x.step() - 2} fill={data[0][col] < 0 ? "url(#neg)" : "url(#pos)"}></rect>
                    {/each}

                    <g transform="translate(0, {x.step() + innerPad})">
                        {#each columns as row, i}
                            <text x=-15 y={x(i) + x.step() / 2 + (i >= issues_names.length ? innerPad : 0)} dominant-baseline="central" text-anchor="end" font-weight=900>{issues_names.includes(row) ? "–" : "+"}</text>
                            <text x=-27 y={x(i) + x.step() / 2 + (i >= issues_names.length ? innerPad : 0)} dominant-baseline="central" text-anchor="end">{dict[row]}</text>

                            <g transform="translate({x(i) + x.step() / 2 + (i >= issues_names.length ? innerPad : 0)}, {-x.step() - 30}) rotate(-90)">
                                <text dominant-baseline="central" text-anchor="start" font-weight=900>{issues_names.includes(row) ? "–" : "+"} </text>
                                <text dominant-baseline="central" text-anchor="start" x=15> {dict[row]}</text>                     
                            </g>

                            <g transform="translate({x(i) + (i >= issues_names.length ? innerPad : 0)}, {-x.step() - 30 - 80})">
                                <rect height={y_occ(occurences[i])} y={-y_occ(occurences[i])} width={x.step() - 2} fill="black"></rect>
                                <g transform="translate({x.step() / 2}, 0) rotate(-90)">
                                    <text 
                                        x={y_occ(occurences[i]) + (occurences[i] >= 20 ? -5 : 5)}
                                        dominant-baseline="central" 
                                        text-anchor={occurences[i] >= 20 ? "end" : "start"}
                                        fill={occurences[i] >= 20 ? "white" : "black"}>
                                        {d3.format(".0f")(occurences[i])}
                                    </text>
                                </g>
                            </g>
                            {#each columns as col, j}
                            <rect x={x(i) + 1 + (i >= issues_names.length ? innerPad : 0)} y={x(j) + 1 + (j >= issues_names.length ? innerPad : 0)} width={x.step() - 2} height={x.step() - 2} fill={c(matrix[i][j])}></rect>
                            <rect x={x(i) + 1 + (i >= issues_names.length ? innerPad : 0)} y={x(j) + 1 + (j >= issues_names.length ? innerPad : 0)} width={x.step() - 2} height={x.step() - 2} fill={matrix[i][j] < 0 ? "url(#neg)" : "url(#pos)"}></rect>
                            {/each}
                        {/each}
                    </g>

                    <!-- Dendograms-->
                    {#each [issue_dendogram, helpful_dendogram].filter(d => d) as dendogram, i}
                        <g transform="translate({width + 30}, {x.step() + 20 + (i == 1 ? x(issues_names.length) + innerPad : 0) + x.step() / 2})">
                            <!-- {#each dendogram.nodes as p}
                                <circle cy={p.x * x.step()} cx={p.depth * 15} r=2 />
                            {/each} -->
                            {#each dendogram.links as p}
                                <path d={link(p)} fill="none" stroke="black" />
                            {/each}
                        </g>
                    {/each}


                    <g transform="translate({width + innerPad + 20 + 100}, -50)">
                        <text>Correlation</text>
                        {#each c.ticks(15) as tick, i}
                            <rect y={10 + i * x.step()} width={x.step() - 2} height={x.step() - 2} fill={c(tick)}></rect>
                            <rect y={10 + i * x.step()} width={x.step() - 2} height={x.step() - 2} fill={tick < 0 ? "url(#neg)" : "url(#pos)"}></rect>
                            <text y={10 + i * x.step() + x.step() / 2} x={x.step() + 46} dominant-baseline="central" text-anchor="end">{tick >= 0 ? ' ': ""}{d3.format(".2f")(tick)}</text>
                        {/each}
                    </g>
                </g>
                <!-- <g transform="translate({300 + width + 2 * margin}, {margin})" bind:this={legendSvg}>
                
                </g> -->

            </svg>
        </Row>

        <Row class="text-right">
            <Button on:click={function() {saveSvg(svg, `correlation-${cvd}.svg`)}}>Save</Button>
        </Row>
    </Container>
</MaterialApp>


